<template>
    <div class="content-body account users-list customers-wrapper">
        <b-row>
            <b-col sm="6" md="2">
                <div class="filter-wrapper">
                    <b-input-group prepend=" " style="width: 300px">
                        <b-form-input
                                @keyup.native="debounceSearchUser"
                                placeholder="Search"
                                v-model="searchString">
                        </b-form-input>
                    </b-input-group>
                </div>
            </b-col>
            <b-col sm="6" md="10" class="text-left text-md-right">
                <b-button v-if="activeUser.role === 'admin'" variant="primary btn-table-add" @click="createUser('form-user')" >+ New User</b-button>
            </b-col>
        </b-row>
        <div class="mt-1">
            <div class="data-container">
                <b-table 
                    :items="users"
                    :fields="fields"
                    :current-page="currentPage"
                    show-empty
                    empty-text="No Records Found"
                    responsive>
                    <template slot="full_name" slot-scope="data">
                        {{ users[data.index].lastname}}, {{ users[data.index].firstname}}
                    </template>
                    <template slot="designation" slot-scope="data">
                        {{ data.value }} <em v-if="data.item.role === 'admin'"> (merchant admin)</em>
                    </template>
                    <template slot="action" slot-scope="data">
                        <div>
                            <b-button-group>
                                <b-button :disabled="data.item.role === 'admin' || activeUser.role !== 'admin'"
                                    variant="ghost btn-table-edit"
                                    @click="data.item.role !== 'admin' || activeUser.role === 'admin' ? editUser('form-user', data) : false" 
                                    class="ml-1"
                                >
                                </b-button>
                                <b-form-checkbox 
                                    v-if="activeUser.role === 'admin'" 
                                    :checked="users[data.index].account_status === 'active'" 
                                    class="switch-cb-activation ml-1" 
                                    switch 
                                    readonly 
                                    @click.native="deactivateOrActivateUser(users[data.index], data.index, $event)"
                                >
                                </b-form-checkbox>
                                <b-button
                                    v-if="activeUser.role === 'admin'"
                                    :disabled="data.item.role === 'admins'"
                                    variant="ghost btn-table-delete"
                                    @click="data.item.role !== 'admin' || activeUser.role === 'admin' ? showDeleteUserModal('delete-user-modal', data.index, users[data.index].uuid) : false" 
                                    class="ml-1"
                                >
                                </b-button>
                            </b-button-group>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <div>
            <b-row>
                <b-col>
                    <div class="mt-1 flex">    
                        <span class="pagination-indicator">{{ pagination.currentFirstItem }}-{{ pagination.currentLastItem }} of {{ pagination.maxPage }} page</span>                    
                        <b-pagination
                            hide-goto-end-buttons
                            hide-ellipsis
                            align="left"
                            size="md"
                            :limit="3"
                            :total-rows="maxPage * users.length"
                            :per-page="users.length"
                            @change="getUsers"
                            :value="currentPage"
                            class="custom-pagination-arrow-only mb-0 ml-2"
                        >
                        </b-pagination>
                    </div>
                </b-col>
                <!-- <b-col>
                    <b-pagination
                            hide-goto-end-buttons
                            align="right"
                            size="md"
                            :limit="3"
                            :total-rows="maxPage * users.length"
                            :per-page="users.length"
                            @change="getUsers"
                            :value="currentPage"
                            class="custom-pagination">
                    </b-pagination>
                </b-col> -->
            </b-row>
        </div>
        <b-modal 
            @click.native.stop
            no-close-on-backdrop
            id="form-user" class="modal-form"
            size="lg modal-lg"
            :title="title"
            @hidden="brandsBranches = initBrandsBranches; brandsBranchesErrors = {}; maxSelectedUserAccessBranches.show = false;">
            <div v-if="initializing && !creating" style="text-align: center">Please wait...</div>
            <b-container fluid v-else>
                <b-row>
                    <b-col sm="12" md="2"><h6 class="align-middle main-label">Employee</h6></b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2"><h6 class="align-middle"></h6></b-col>
                    <b-col cols="5">
                        <b-form-group label="First Name"
                                      label-for="firstName"
                                      :invalid-feedback="errorMessage('firstname')"
                                      :state="isValid('firstname')"
                                      class="sl-helper">
                            <b-form-input v-model="form.firstName" maxlength="30" id="firstName" type="text" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="5">
                        <b-form-group label="Last Name"
                                      label-for="lastName"
                                      :invalid-feedback="errorMessage('lastname')"
                                      :state="isValid('lastname')"
                                      class="sl-helper">
                            <b-form-input v-model="form.lastName" maxlength="30" id="lastName" type="text" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2"><h6 class="align-middle"></h6></b-col>
                    <b-col cols="5">
                        <b-form-group label="ID No."
                                      label-for="idNumber"
                                      :invalid-feedback="errorMessage('id_number')"
                                      :state="isValid('id_number')"
                                      class="sl-helper">
                            <b-form-input v-model="form.idNumber" id="idNumber" maxlength="20" type="text" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="5">
                        <b-form-group label="Designation"
                                      label-for="designation"
                                      :invalid-feedback="errorMessage('designation')"
                                      :state="isValid('designation')"
                                      class="sl-helper">
                            <b-form-input v-model="form.designation" maxlength="50" id="designation" type="text" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12" md="2"><h6 class="align-middle"></h6></b-col>
                    <b-col cols="5">
                        <b-form-group label="Email"
                                      label-for="email"
                                      :invalid-feedback="errorMessage('email')"
                                      :state="isValid('email')"
                                      class="sl-helper">
                            <b-form-input v-model="form.email" id="email" type="email" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>
                    <b-col cols="5">
                        <b-form-group label="Mobile No."
                                      label-for="mobileNumber"
                                      :invalid-feedback="errorMessage('mobile')"
                                      :state="isValid('mobile')"
                                      class="sl-helper">
                            <b-form-input v-model="form.mobile" id="mobileNumber" maxlength="11" :formatter="mobileFormatter" type="number" placeholder=""></b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col cols="12"><hr></b-col>
                    <b-col></b-col>
                </b-row>
                <b-row no-gutters>
                    <b-col sm="12" md="2">
                        <h6 class="main-label main-label">Access</h6>
                    </b-col>
                    <b-col>
                        <b-row>
                            <template v-for="cmsModuleOption in cmsModuleOptions">
                              <b-col cols="12" v-if="isValidParentModule(cmsModuleOption.code)" :key="cmsModuleOption.id">
                                <b-form-checkbox :ref="cmsModuleOption.code+'Parent'"
                                                 class="checkbox-group"
                                                 v-model="selectedModuleGroup[cmsModuleOption.code]"
                                                 @change="enableGroupModules(cmsModuleOption.code)"
                                                 :id="cmsModuleOption.code + '.parent'">
                                    <template v-if="planId == 5 && cmsModuleOption.name == 'Customers'">
                                        Transactions
                                    </template>
                                    <template v-else-if="cmsModuleOption.name == 'Fulfillment'">
                                        Order Fulfillment
                                    </template>
                                    <template v-else>
                                        {{ cmsModuleOption.name }}
                                    </template>
                                </b-form-checkbox>
                                <b-form-checkbox-group 
                                    id="moduleAccess"
                                    name="moduleAccess"
                                    v-model="selectedModuleAccess"
                                >
                                    <b-row>
                                        <template 
                                            v-for="childModule in cmsModuleOption.child_modules"
                                        >
                                            <b-col 
                                                v-if="isValidChildModule(cmsModuleOption.code, childModule.code)" 
                                                cols="6" 
                                                :key="childModule.id"
                                            >
                                                <b-form-checkbox  
                                                    class="ml-4 checkbox-group"
                                                    :disabled="defaultAccess.indexOf(cmsModuleOption.code + '.' + childModule.code) > -1 || disabledSubmoduleCodes.includes(childModule.code)"
                                                    :id="cmsModuleOption.code + '.' + childModule.code +'.child'"
                                                    :ref="cmsModuleOption.code"
                                                    :value="cmsModuleOption.code + '.' + childModule.code"
                                                >
                                                    <template v-if="planId == 5 && childModule.name == 'Transaction History'">
                                                        Transactions
                                                    </template>
                                                    <template v-else-if="childModule.code == 'loyalty-quicksight'">
                                                        Loyalty Analytics
                                                    </template>
                                                    <template v-else-if="childModule.code == 'inventory:topup-estore'">
                                                        Products
                                                    </template>
                                                    <template v-else>
                                                        <span>{{childModule.name}}</span>
                                                    </template>
                                                    <span v-if="defaultAccess.indexOf(cmsModuleOption.code + '.' + childModule.code) > -1"> (default)</span>
                                                </b-form-checkbox>
                                            </b-col>
                                        </template>
                                    </b-row>
                                </b-form-checkbox-group>
                                <template v-if="cmsModuleOption.name == 'Store' && brandsBranchesVisibility">
                                    <div class="pl-4">
                                        <template v-for="(brandBranch, brandBranchIndex) in brandsBranches">
                                            <b-row :key="brandBranchIndex">
                                                <b-col>
                                                    <span class="checkbox-group">Brands</span>
                                                    <b-form-select
                                                        :id="'brandBranch' + brandBranchIndex"
                                                        v-model="brandBranch.brand"
                                                        :ref="'brandBranch' + brandBranchIndex"
                                                        @input="isBrandDuplicate(brandBranch.brand, brandBranchIndex)"
                                                        @change="clearBranches(brandBranchIndex)"
                                                    >
                                                        <option :value="''">Select Option</option>
                                                        <option :value="brand.name + ':' + brand.uuid + ';'" v-for="(brand, index) in brands" :key="index">{{ brand.name }}</option>
                                                    </b-form-select>
                                                    <b-form-invalid-feedback
                                                        :class="['mb-3', { 'd-block': Object.keys(brandsBranchesErrors).length > 0 && Object.keys(brandsBranchesErrors).includes(`${brandBranchIndex}`) ? true : false }]"
                                                        v-if="Object.keys(brandsBranchesErrors).length > 0 && Object.keys(brandsBranchesErrors).includes(`${brandBranchIndex}`) ? true : false "
                                                        :state="Object.keys(brandsBranchesErrors).length === 0 && !Object.keys(brandsBranchesErrors).includes(`${brandBranchIndex}`) ? null : false">
                                                        {{ brandsBranchesErrors[brandBranchIndex] }}
                                                    </b-form-invalid-feedback>
                                                </b-col>
                                                <b-col>
                                                    <span class="checkbox-group">Branches</span>
                                                    <small
                                                      v-if="brandBranch.branches.length"
                                                      class="ml-1 text-primary"
                                                    >
                                                      ( {{ brandBranch.branches.length }} Selected )
                                                    </small>
                                                    <b-form-group
                                                        label-for="branches"
                                                        label-class="secondary-label"
                                                        class="position-relative"
                                                        id="branches-group"
                                                    >
                                                        <b-input-group>
                                                            <b-input-group
                                                                slot="prepend"
                                                                class="border rounded-left px-2 d-flex align-items-center"
                                                            >
                                                                <template v-if="brandBranch.is_search">
                                                                    <i class="ic-search"></i>
                                                                </template>
                                                                <template v-else>
                                                                    <b-button variant=" btn-remove shadow-none" @click="hideBranchList(brandBranchIndex)"></b-button>
                                                                </template>
                                                            </b-input-group>
                                                            <b-form-input
                                                                :disabled="brandBranch.brand == ''"
                                                                v-model="branchKeyword"
                                                                @focus.native="showBranchList(brandBranchIndex)"
                                                                @keyup="searchBranch(brandBranch.brand.substring(brandBranch.brand.lastIndexOf(':') + 1, brandBranch.brand.lastIndexOf(';')))"
                                                                autocomplete="off"
                                                                placeholder="Search by city"
                                                            ></b-form-input>
                                                        </b-input-group>
                                                        <div
                                                            :id="'branch-list-' + brandBranchIndex"
                                                            :ref="'branchList' + brandBranchIndex"
                                                            class="position-absolute bg-white w-100 d-none branch-list"
                                                        >
                                                        <ul class="p-0 m-0 d-flex flex-column">
                                                            <template v-if="branchLoading">
                                                                <li>Loading Branches...</li>
                                                            </template>
                                                            <template v-else-if="filteredCitiesByBrand[brandBranch.brand.substring(brandBranch.brand.lastIndexOf(':') + 1, brandBranch.brand.lastIndexOf(';'))] === undefined">
                                                                <li>No available branches</li>
                                                            </template>
                                                            <template v-else>
                                                                <div role="tablist">
                                                                    <b-card no-body class="mb-1" 
                                                                    v-for="(city, a) in filteredCitiesByBrand[brandBranch.brand.substring(brandBranch.brand.lastIndexOf(':') + 1, brandBranch.brand.lastIndexOf(';'))]" :key="a">
                                                                        <b-card-header header-tag="header" class="px-2 pt-0 pb-2" role="tab">
                                                                            <div
                                                                                v-b-toggle="'branchAccordion' + a"
                                                                                class="d-inline-block action-button"
                                                                                style="width: 4%; position: relative; top: -3px; z-index: 10;"
                                                                            >
                                                                                <img
                                                                                    src="@/assets/images/icons/collapse.svg"
                                                                                    alt="Collapsed Icon"
                                                                                    class="d-inline-block mr-3 when-closed"
                                                                                    style="width: 14px; height: 14px;"
                                                                                />
                                                                                <img
                                                                                    src="@/assets/images/icons/expand.svg"
                                                                                    alt="Expand Icon"
                                                                                    class="d-inline-block mr-3 when-opened"
                                                                                    style="width: 14px; height: 14px; position: relative; z-index: 10;"
                                                                                />
                                                                            </div>
                                                                            <span class="d-inline-block ml-3">{{ city }}</span>
                                                                            <div
                                                                              v-if="
                                                                                branches[
                                                                                  brandBranch.brand.substring(
                                                                                    brandBranch.brand.lastIndexOf(
                                                                                      ':'
                                                                                    ) + 1,
                                                                                    brandBranch.brand.lastIndexOf(
                                                                                      ';'
                                                                                    )
                                                                                  ) +
                                                                                    '-' +
                                                                                    city
                                                                                ].filter(({ uuid }) =>
                                                                                  brandBranch.branches.includes(
                                                                                    uuid
                                                                                  )
                                                                                ).length
                                                                              "
                                                                              class="text-primary ml-4"
                                                                            >
                                                                              ( {{
                                                                                branches[
                                                                                  brandBranch.brand.substring(
                                                                                    brandBranch.brand.lastIndexOf(
                                                                                      ":"
                                                                                    ) + 1,
                                                                                    brandBranch.brand.lastIndexOf(
                                                                                      ";"
                                                                                    )
                                                                                  ) +
                                                                                    "-" +
                                                                                    city
                                                                                ].filter(({ uuid }) =>
                                                                                  brandBranch.branches.includes(
                                                                                    uuid
                                                                                  )
                                                                                ).length
                                                                              }}
                                                                              Selected )
                                                                            </div>
                                                                        </b-card-header>
                                                                        <b-collapse :id="'branchAccordion' + a" visible accordion="my-accordion" role="tabpanel">
                                                                            <b-card-body class="p-0">
                                                                                <b-form-checkbox-group
                                                                                    :id="'branchCheckboxGroup' + brandBranchIndex + a"
                                                                                    v-model="brandBranch.branches"
                                                                                >
                                                                                    <li
                                                                                        v-for="(branch, b) in branches[brandBranch.brand.substring(brandBranch.brand.lastIndexOf(':') + 1, brandBranch.brand.lastIndexOf(';')) + '-' + city]" :key="b"
                                                                                        class="d-flex align-items-center border-bottom pt-1 pb-1 pr-1"
                                                                                        style="padding-left: 40px;"
                                                                                    >
                                                                                        <br>
                                                                                        <b-form-checkbox
                                                                                            :id="'branchCheckbox' + brandBranchIndex + a + b"
                                                                                            :value="branch.uuid"
                                                                                            unchecked-value=""
                                                                                            class="mt-2 ml-2 mr-0 mb-0 pl-2"
                                                                                            @input="selectedUserAccessBranchesChecker"
                                                                                        ></b-form-checkbox>
                                                                                        <span class="flex-grow-1">{{ branch.name }}</span>
                                                                                    </li>
                                                                                </b-form-checkbox-group>
                                                                            </b-card-body>
                                                                        </b-collapse>
                                                                    </b-card>
                                                                </div>
                                                            </template>
                                                        </ul>
                                                        </div>
                                                    </b-form-group>
                                                </b-col>
                                                <b-col cols="1">
                                                    <i
                                                        v-if="brandsBranches.length > 1"
                                                        class="action-button ml-1"
                                                        style="position: relative; left: -26px; top: 30px"
                                                        @click="deleteBrandBranch(brandBranchIndex)"
                                                    >
                                                        <img
                                                            src="@/assets/images/actions/delete.svg"
                                                            alt="Delete Button"
                                                        />
                                                    </i>
                                                </b-col>
                                            </b-row>
                                        </template>
                                        <b-row>
                                            <b-col>
                                                <b-btn  variant="primary" class="add-more-button mb-3 d-inline-block" @click="addBrandBranch()">
                                                    + Add More
                                                </b-btn>
                                            </b-col>
                                        </b-row>
                                        <b-row>
                                            <b-form-invalid-feedback
                                                :class="['mb-3', { 'd-block': maxSelectedUserAccessBranches.show }]"
                                                v-if="maxSelectedUserAccessBranches.show"
                                                :state="maxSelectedUserAccessBranches.show ? null : false">
                                                {{ maxSelectedUserAccessBranches.message }}
                                            </b-form-invalid-feedback>
                                        </b-row>
                                        <b-row>
                                            <div class="rounded bg-light mb-3 py-2 px-3 d-inline-flex align-items-start">
                                                <img src="@/assets/images/el_info-circle.svg" alt="info" class="position-relative mr-2" style="top: 4px;">
                                                <p class="m-0 p-0">Selecting a brand already includes all of its branches. While selecting a specific branch removes all except the selected branch. Only up to 10 specific branches are allowed per user regardless of the number of brands.</p>
                                            </div>
                                        </b-row>
                                    </div>
                                </template>
                                <hr />
                              </b-col>
                            </template>
                        </b-row>
                    </b-col>
                </b-row>
            </b-container>
            <div slot="modal-footer">
                <b-btn :disabled="loading" variant="ghost" @click="handleCancel('form-user')" class="mr-1 btn-cancel">
                    Cancel
                </b-btn>
                <b-btn :disabled="initializing || loading" variant="primary" @click="handleSave('form-user')" class="ml-1">
                    {{ loading ? 'Saving...' : 'Save' }}
                </b-btn>
            </div>
        </b-modal>

        <b-modal 
            id="activate-or-deactivate-user-modal" class="modal-form"
            @click.native.stop
            :no-close-on-backdrop="true"
            size="lg modal-lg"
            hide-header
            hide-header-close 
            hide-footer
        >
        <div class="d-block text-left">
            <p><img src="@/assets/images/warning.svg" alt="warning icon" width="30" height="30" id="warning-icon">&nbsp;&nbsp;<span style="font-family: MainFontBold, sans-serif; font-weight: normal; font-size: 17pt;"> Deactivate User</span></p>
        </div>
        <div class="d-block tex-left">
            <p class="pl-5"><span style="font-size: 11pt; font-weight: normal;">Are you sure you want to deactivate this user? User access will be suspended.</span></p>
        </div>
        <div class="d-block text-right">
            <b-button class="cancel-btn" @click="handleCancel('activate-or-deactivate-user-modal')">Cancel</b-button>
            <b-button class="ml-2" variant="primary btn-table-add" @click="deactivateUser()" >Deactivate</b-button>
        </div>
        </b-modal>
        
        <b-modal 
            id="delete-user-modal" class="modal-form"
            @click.native.stop
            :no-close-on-backdrop="true"
            size="lg modal-lg"
            hide-header
            hide-header-close 
            hide-footer
        >
        <div class="d-block text-left">
            <p><img src="@/assets/images/warning.svg" alt="warning icon" width="30" height="30" id="warning-icon">&nbsp;&nbsp;<span style="font-family: MainFontBold, sans-serif; font-weight: normal; font-size: 17pt;"> Delete User</span></p>
        </div>
        <div class="d-block tex-left">
            <p class="pl-5"><span style="font-size: 11pt; font-weight: normal;">Are you sure you want to delete this user? User account will no longer available.</span></p>
        </div>
        <div class="d-block text-right">
            <b-button class="cancel-btn" @click="handleCancel('delete-user-modal')">Cancel</b-button>
            <b-button class="ml-2" variant="primary btn-table-add" @click="deleteUser()" >Delete</b-button>
        </div>
        </b-modal>
    </div>
</template>

<script>
import Switches from "vue-switches";
import Datepicker from "vue-bulma-datepicker";
import userFormInit from "../../services/account.users.form";
import Auth from "../../services/auth.js";
import { directive as onClickaway } from "vue-clickaway";
import permission from "@/services/user.permission";
import _ from "lodash";

import { mapState, mapGetters } from "vuex";

const customer = {};

function initBrandsBranches() {
    return [
        {
            brand: "",
            branches: [],
            is_search: true,
            cities: []
        }
    ];
}

export default {
    name: "Users",
    components: {
        Switches,
        Datepicker
    },
    data() {
        return {
            userIndex: "",
            userUuid: "",
            mode: "",
            activeUser: null,
            selected: null,
            perPage: 10,
            totalRows: 100,
            searchString: "",
            searchPayload: {},
            selectedModuleAccess: [],
            activeModuleAccessId: null,
            isModulesAreReady: false,
            defaultAccess: [
                "account-settings.my-profile",
                "account-settings.security"
            ],
            fields: [
                {
                    key: "id_number",
                    sortable: true,
                    label: "Employee ID"
                },
                {
                    key: "full_name",
                    sortable: true
                },
                {
                    key: "designation",
                    sortable: true
                },
                {
                    key: "email",
                    sortable: true
                },
                {
                    key: "mobile",
                    sortable: true
                },
                "action"
            ],
            customer: customer,
            selectedFilter: 0,
            selectedModuleGroup: [],
            title: "",
            selectedBrand: "",
            branchKeyword: "",
            is_search: true,
            selected_voucher: [],
            added_vouchers: [],
            brandsBranches: initBrandsBranches(),
            initBrandsBranches: initBrandsBranches(),
            unselectFromBranch: false,
            brandsBranchesErrors: {},
            maxSelectedUserAccessBranches: {
                show: false,
                message: "You have reached the maximum allowed number of assigning a branch to a user."
            },
            planModuleCodes: permission.getPlanModuleCodes(),
            filteredCitiesByBrand: null,
            disabledAccessCodes: ["analytics.loyalty-quicksight", "analytics.estore-quicksight"],
            disabledSubmoduleCodes: ["loyalty-quicksight", "estore-quicksight"]
        };
    },
    computed: {
        ...mapState("accountUsers", [
            "loading",
            "errors",
            "users",
            "cmsModuleOptions",
            "enabledCmsPermissions",
            "nextPage",
            "prevPage",
            "maxPage",
            "currentPage",
            "creating",
            "initializing",
            "form",
            "pagination"
        ]),
        ...mapState("auth", {
            planId: state => state.planId,
            user: state => state.user,
            isCartLinkingEnabled: state => state.isCartLinkingEnabled,
        }),
        ...mapState("branches", {
            cities: state => state.cities,
            citiesByBrand: state => state.citiesByBrand,
            branches: state => state.branches,
            branchErrors: state => state.errors,
            branchLoading: state => state.loading,
            branchCreated: state => state.created,
            branchUpdated: state => state.updated,
            branchDeleted: state => state.deleted,
            branchImported: state => state.imported,
            branchTableList: state => state.branchTableList
        }),
        ...mapState("brands", {
            brands: state => state.brands,
            brandErrors: state => state.errors,
            brandLoading: state => state.loading,
            brandCreated: state => state.created,
            brandUpdated: state => state.updated,
            brandDeleted: state => state.deleted
        }),
        ...mapGetters("accountUsers", {
            userBrandBranches: "userBrandBranches"
        }),
        brandsBranchesVisibility() {
            return this.selectedModuleAccess
                .map(access => {
                    return access.includes("store.organization");
                })
                .includes(true);
        },
        transformedBrandBranchesForChecking() {
            return this.brands.length > 0
                ? this.brands.map(brand => {
                      return {
                          value: `${brand.name}:${brand.uuid};`,
                          uuid: brand.uuid
                      };
                  })
                : this.brands;
        },
        selectedUserAccessBranches() {
            return this.brandsBranches.map(brandBranch => brandBranch.branches).flat();
        }
    },
    created() {
        this.$store.dispatch("brands/getBrands");
        this.$store.dispatch("branches/getBranches");
        this.initPage();
        this.initForm();
        this.filteredCitiesByBrand = _.cloneDeep(this.citiesByBrand);
        this.debounceSearchUser = _.debounce(() => {
          this.search();
        }, 300);
    },
    methods: {
        async initPage() {
            this.activeUser = Auth.getUser();
            await this.getUsers(1);
            this.getCmsModuleOptions();
        },
        initForm() {
            let _form = userFormInit.formInit();
            this.$store.dispatch("accountUsers/resetForm", _form);
        },
        getUsers(page) {
            let param = {
                page: page,
                payload: this.searchPayload
            };
            this.$store.dispatch("accountUsers/getUsers", param);
        },
        search() {
            this.searchPayload = {
                search: this.searchString
            };
            this.getUsers(1);
        },
        getCmsModuleOptions() {
            this.$store.dispatch("accountUsers/getCmsModuleOptions");
        },
        mobileFormatter(value, event) {
            return event === null
                ? value
                : value.replace(/\./gi, "").substring(0, 11);
        },
        showModal(modal) {
            this.$root.$emit("bv::show::modal", modal);
        },
        hideModal(modal) {
            this.$root.$emit("bv::hide::modal", modal);
        },
        handleCancel(modal) {
            this.hideModal(modal);
            this.userIndex = "";
            this.userUuid = "";
            this.mode = "";
        },
        async createUser(modal) {
            await this.initForm();
            this.selectedModuleAccess = [
                "account-settings.my-profile",
                "account-settings.security"
            ];
            await this.$store.commit("accountUsers/errors", null);
            this.title = "Create New User";
            await this.$store.commit("accountUsers/activeUserUuid", null);
            await this.$store.commit("accountUsers/creating", true);
            await this.showModal(modal);
            this.clearGroupSelector();
        },
        editUser(modal, data) {
            this.title = "Edit User";
            let details = data.item;
            this.$store.commit("accountUsers/activeUserUuid", details.uuid);
            this.$store.commit("accountUsers/creating", false);
            this.initForm();
            this.selectedModuleAccess = [];
            let _this = this;

            this.$store
                .dispatch(
                    "accountUsers/getCmsModuleAccess",
                    details.module_access_id
                )
                .then(result => {
                    _this.selectedModuleAccess = result;
                    _this.form.firstName = details.firstname;
                    _this.form.lastName = details.lastname;
                    _this.form.email = details.email;
                    _this.form.mobile = details.mobile;
                    _this.form.idNumber = details.id_number;
                    _this.form.designation = details.designation;
                    _this.activeModuleAccessId = details.module_access_id;
                    _this.enableGroupSelector();
                });
            this.$store
                .dispatch("accountUsers/getUserDetails", data.item.uuid)
                .then(this.checkSelectedBrandsBranches);

            this.showModal(modal);
        },
        deactivateOrActivateUser(data, index, event) {
            event.preventDefault();

            if(data.account_status === 'active') {
                this.$root.$emit("bv::show::modal", 'activate-or-deactivate-user-modal');
                this.userUuid = data.uuid;
                this.mode = "deactivate";
                this.userIndex = index;
            } else {
                this.userUuid = "";
                this.mode = ""
                let param = {
                    mode: "activate",
                    user_uuid: data.uuid
                }
                let _this = this;
                this.$store.dispatch("accountUsers/activateOrDeactivateUser", param).then(function() {
                    if (_this.errors != null) {
                        return true;
                    }
                });
                this.$nextTick(() => {
                    this.users[index].account_status = "active"
                    this.userIndex = "";
                })
            }
        },
        deactivateUser() {
            let param = {
                mode: this.mode,
                user_uuid: this.userUuid
            }
            let _this = this;
            this.$store.dispatch("accountUsers/activateOrDeactivateUser", param).then(function() {
                if (_this.errors != null) {
                    return true;
                }
            });
            this.$nextTick(() => {
                this.$root.$emit("bv::hide::modal", 'activate-or-deactivate-user-modal');
                this.users[this.userIndex].account_status = "deactivated";
                this.userIndex = "";
            })
        },
        showDeleteUserModal(modal, index, uuid) {
            this.userIndex = index;
            this.userUuid = uuid;
            this.$root.$emit("bv::show::modal", modal);
        },
        deleteUser() {
            let param = { user_uuid: this.userUuid }
            let _this = this;
            this.$store.dispatch("accountUsers/deleteUser", param).then(function() {
                if (_this.errors != null) {
                    return true;
                }
            });
            this.$nextTick(() => {
                this.users.splice(this.userIndex, 1);
                this.userIndex = "";
            })
            _this.$root.$emit("bv::hide::modal", "delete-user-modal");
        },
        handleSave(modal) {
            this.$store.commit("accountUsers/errors", null);

            let isCartLinkingIncluded = this.selectedModuleAccess.includes("estore:topup.cartlinking:topup-estore");

            if (isCartLinkingIncluded) {
                if (!(this.selectedModuleAccess.includes("estore-products.inventory:topup-estore"))) {
                    this.selectedModuleAccess.push("estore-products.inventory:topup-estore");    
                }

                if (!(this.selectedModuleAccess.includes("estore-settings.settings:topup-estore"))) {
                    this.selectedModuleAccess.push("estore-settings.settings:topup-estore");    
                }

                if (!(this.selectedModuleAccess.includes("estore-orders.orders:topup-estore"))) {
                    this.selectedModuleAccess.push("estore-orders.orders:topup-estore");    
                }
                
            }

            let data = {
                firstname: this.form.firstName,
                lastname: this.form.lastName,
                id_number: this.form.idNumber,
                designation: this.form.designation,
                email: this.form.email,
                mobile: this.form.mobile,
                moduleAccess: this.selectedModuleAccess
            };

            if (this.brandsBranchesVisibility) {
                this.brandsBranchesErrors = new Object(); // always clear errors
                this.brandsBranches.map((brandBranch, brandBranchIndex) => {
                    if (brandBranch.brand === "") {
                        if (
                            Object.keys(this.brandsBranchesErrors).includes(brandBranchIndex)
                        ) {
                            this.brandsBranchesErrors[brandBranchIndex] = "Brand is required";
                        } else {
                            this.$set(
                                this.brandsBranchesErrors,
                                brandBranchIndex,
                                "Brand is required"
                            );
                        }
                    }
                });
            }

            this.$nextTick(() => {
                if (
                    this.brandsBranchesVisibility &&
                    Object.keys(this.brandsBranchesErrors).length === 0
                ) {
                    data.brands = this.brandsBranches.map(brand =>
                        brand.brand
                            .split(":")
                            .pop()
                            .replace(";", "")
                    );
                    data.branches = this.brandsBranches
                        .map(brand => brand.branches)
                        .flat();
                    proceedSave();
                } else if (!this.brandsBranchesVisibility) {
                    proceedSave();
                }
            });

            const proceedSave = () => {
                this.$store.commit("accountUsers/loading");
                let _event = this.creating
                    ? "accountUsers/createUser"
                    : "accountUsers/updateUser";
                if (_event === "accountUsers/updateUser") {
                    data.moduleAccessId = this.activeModuleAccessId;
                }

                let _this = this;
                this.$store.dispatch(_event, data).then(function() {
                    if (_this.errors == null) {
                        _this.hideModal(modal);
                    }
                });
            };
        },
        async enableGroupModules(moduleGroup) {
            let _this = this;
            let checked = !this.selectedModuleGroup[moduleGroup];
            this.selectedModuleGroup[moduleGroup] = checked;
            if (checked) {
                _.forEach(this.$refs[moduleGroup], function(value) {
                    if (_this.disabledAccessCodes.includes(value.$refs.input.value))
                      return;

                    value.$refs.input.checked = true;
                    let i = _this.selectedModuleAccess.indexOf(
                        value.$refs.input.value
                    );
                    if (i === -1) {
                        _this.selectedModuleAccess.push(
                            value.$refs.input.value
                        );
                    }
                });
            } else {
                _.forEach(this.$refs[moduleGroup], function(value) {
                    if (_this.disabledAccessCodes.includes(value.$refs.input.value))
                      return;

                    if (
                        _this.defaultAccess.indexOf(value.$refs.input.value) ===
                        -1
                    ) {
                        value.$refs.input.checked = false;
                        let i = _this.selectedModuleAccess.indexOf(
                            value.$refs.input.value
                        );
                        if (i !== -1) {
                            _this.selectedModuleAccess.splice(i, 1);
                        }
                    }
                });
            }
        },
        clearGroupSelector() {
            this.selectedModuleGroup = [];
        },
        enableGroupSelector() {
            let access = [];
            let _this = this;
            let copy = null;
            let count = 0;
            _.forEach(this.selectedModuleAccess, function(value) {
                let v = value.split(".");
                count = copy === v[0] || copy === null ? count + 1 : 1;
                access[v[0]] = count;
                copy = v[0];
            });
            _.forEach(this.cmsModuleOptions, function(value) {
                let code = value.code;
                let length = value.child_modules.length;
                _this.selectedModuleGroup[code] = access[code] === length;
            });
        },
        isValid(field) {
            if (this.errors == null) {
                return false;
            }
            return this.errors.errors[field] ? false : true;
        },
        errorMessage(field) {
            if (this.errors == null) {
                return "";
            }
            return this.errors.errors[field];
        },
        isValidParentModule(code) {
            if (!this.planModuleCodes.some(moduleCode => moduleCode.includes(code)))
                return false;

            let topUpsForMarketplace = ["rewards", "customers", "store"];

            if (this.planId == 5) {
                if (!topUpsForMarketplace.includes(code)) {
                    return false;
                }
            }

             // FULFILLMENT MODULE IS INCLUDED IN ESTORE TOPUP MODULE
            if (code.includes('fulfillment')) 
                return Auth.getEnabledTopUps().indexOf('estore') !== -1 ;
            
            if (code === 'privilege-card')
                return Auth.getEnabledTopUps().includes("privilege_card");
            
            if (!code.includes("topup")) return true;

            let partial = code.split(":");
            let topUpCode = partial[0];

            if (topUpCode === "vouchers")
                topUpCode = "voucher";

            return Auth.getEnabledTopUps().indexOf(topUpCode) !== -1;
        },
        isValidChildModule(parentCode, childCode) {
            if (parentCode === "estore:topup" && childCode === "cartlinking:topup-estore") {
                if (!(this.planModuleCodes.includes("estore:topup.cartlinking:topup-estore") && 
                        this.user.cms_permissions.includes("estore:topup.cartlinking:topup-estore") &&
                        this.isCartLinkingEnabled)) {
                    return false;
                }
            }
            if (parentCode === "account-settings" && childCode === "documents") 
                return false;

            let childModulesForMarketplace = [
                "my-rewards",
                "transaction-history",
                "organization",
                "employee"
            ];
            
            // REMOVE MECHANICS DESIGN AS WE HAVE A SEPARATE DESIGN MODULE
            if (parentCode === 'mechanics' && childCode === 'design') 
                return false;

            if (this.planId == 5) {
                if (!childModulesForMarketplace.includes(childCode)) {
                    return false;
                }
            }

            if (childCode === "privilege-card")
                return this.planModuleCodes.some(moduleCode => moduleCode.includes(childCode)) && 
                    Auth.getEnabledTopUps().includes("privilege_card") 

            if (!childCode.includes("topup")) 
                return this.planModuleCodes.some(moduleCode => moduleCode.includes(childCode));

            let partial = childCode.split(":");
            let secondPartial = partial[1].split("-");
            let topUpCode = secondPartial[1];
            
            if (topUpCode === "vouchers")
                topUpCode = "voucher";

            return Auth.getEnabledTopUps().indexOf(topUpCode) !== -1;
        },
        showBranchList: function(brandBranchIndex) {
            this.filteredCitiesByBrand = _.cloneDeep(this.citiesByBrand);
            let refName = "branchList" + brandBranchIndex;
            // Hide All List First Before Opening A Specific List
            for (let index = 0; index < this.brandsBranches.length; index++) {
                let individualRef = "branchList" + index;
                this.$refs[individualRef][0].classList.add("d-none");
                this.brandsBranches[index].is_search = true;
            }
            this.brandsBranches[brandBranchIndex].is_search = false;
            this.$refs[refName][0].classList.remove("d-none");
        },
        hideBranchList: function(brandBranchIndex) {
            let refName = "branchList" + brandBranchIndex;
            this.is_search = true;
            this.brandsBranches[brandBranchIndex].is_search = true;
            this.$refs[refName][0].classList.add("d-none");
        },
        addBrandBranch() {
            // Hide Every Shown List When Adding A New Brand
            for (let index = 0; index < this.brandsBranches.length; index++) {
                let individualRef = "branchList" + index;
                this.$refs[individualRef][0].classList.add("d-none");
                this.brandsBranches[index].is_search = true;
            }
            this.brandsBranchesErrors = {};
            this.$nextTick(() => {
                this.brandsBranches.push({
                    brand: "",
                    branches: [],
                    is_search: true,
                    cities: []
                });
            });
        },
        addAll() {
            this.brandsBranches = initBrandsBranches();
            const allBrandsBranches = [];
            this.brandsBranchesErrors = {};

            this.$nextTick(() => {
                this.brands.map(brand => {
                    allBrandsBranches.push({
                        brand: `${brand.name}:${brand.uuid};`,
                        selectAll: true,
                        branches: [],
                        is_search: true,
                        cities: this.cities.map(() => {
                            return { selectAll: true };
                        })
                    });
                });
                this.brandsBranches = allBrandsBranches;
                allBrandsBranches.forEach((brandBranches, index) => {
                    const branchesCollection = [];
                    Object.keys(this.branches).forEach(branch => {
                        if (
                            branch.substring(0, branch.lastIndexOf("-")) ===
                            `${brandBranches.brand
                                .replace(";", "")
                                .split(":")
                                .pop()}`
                        ) {
                            branchesCollection.push(
                                this.branches[branch]
                                    .flat()
                                    .map(deepBranch => deepBranch.uuid)
                            );
                        }
                    });
                    this.brandsBranches[
                        index
                    ].branches = branchesCollection.flat();
                });
            });
        },
        deleteBrandBranch(brandBranchIndex) {
            this.brandsBranches.splice(brandBranchIndex, 1);
        },
        isBrandDuplicate(brand, brandBranchIndex) {
            let cities = this.citiesByBrand[
                brand.substring(
                    brand.lastIndexOf(":") + 1,
                    brand.lastIndexOf(";")
                )
            ];

            if (Array.isArray(cities)) {
              cities.forEach(_ => {
                this.brandsBranches[brandBranchIndex].cities.push({
                  selectAll: false
                });
              });
            }
            const result = this.brandsBranches.filter(function(brandBranch) {
                return brandBranch.brand == brand;
            });
            // Remove Duplicate and Refocus It on First Input
            if (result.length >= 2) {
                const mappedBrandsBranches = this.brandsBranches.map(
                    brandBranch => brandBranch.brand
                );

                const firstIndex = mappedBrandsBranches.indexOf(brand);
                const duplicateIndex = mappedBrandsBranches.lastIndexOf(brand);
                this.brandsBranches.splice(duplicateIndex, 1);
                let refName = "brandBranch" + firstIndex;
                this.$refs[refName][0].$el.focus();
            }
        },
        checkSelectedBrandsBranches() {
            const brandsBranches = [];
            const isBrandsBranches = this.userBrandBranches.brands.concat(
                this.userBrandBranches.branches
            );

            if (isBrandsBranches.length > 0) {
                this.userBrandBranches.brands.map(uuid => {
                    const brand = this.transformedBrandBranchesForChecking.find(
                        brand => brand.uuid === uuid
                    );
                    const branchesCollection = [];
                    Object.keys(this.branches).forEach(branch => {
                        if (
                            branch.substring(0, branch.lastIndexOf("-")) ===
                            uuid
                        ) {
                            this.userBrandBranches.branches.map(branch_uuid => {
                                if (
                                    this.branches[branch]
                                        .flat()
                                        .map(deepBranch => deepBranch.uuid)
                                        .includes(branch_uuid)
                                ) {
                                    branchesCollection.push(branch_uuid);
                                }
                            });
                        }
                    });
                    this.$nextTick(() => {
                        brandsBranches.push({
                            brand: brand.value,
                            selectAll: false,
                            branches: branchesCollection.flat(),
                            is_search: true,
                            cities: this.cities.map(() => {
                                return {
                                    selectAll: false
                                };
                            })
                        });
                    });
                });
            } else {
                brandsBranches.push({
                    brand: "",
                    selectAll: false,
                    branches: "",
                    is_search: true,
                    cities: this.cities.map(() => {
                        return {
                            selectAll: false
                        };
                    })
                });
            }
            this.$nextTick(() => {
                this.brandsBranches = brandsBranches;
            });
        },
        clearBranches(brandBranchIndex) {
            this.brandsBranches[brandBranchIndex].branches = [];
        },
        selectedUserAccessBranchesChecker() {
            const excessBranch = this.selectedUserAccessBranches[10];
            if (excessBranch !== undefined) {
                this.maxSelectedUserAccessBranches.show = true;
                this.brandsBranches.map((branch, index) => {
                    if (branch.branches.includes(excessBranch)) {
                        const branchIndex = this.brandsBranches[index].branches.indexOf(excessBranch);
                        this.brandsBranches[index].branches.splice(branchIndex, 1);
                    }
                });
            } else {
                this.maxSelectedUserAccessBranches.show = false;
            }
        },
        searchBranch(key) {
          this.filteredCitiesByBrand = _.cloneDeep(this.citiesByBrand);
          this.filteredCitiesByBrand[key] = this.citiesByBrand[key].filter(
            city => city.toLowerCase().includes(this.branchKeyword)
          )
        }
    },
    directives: {
        onClickaway: onClickaway
    }
};
</script>
<style lang="scss">
div[id^="branchCheckboxGroup"] {
    .custom-radio .custom-control-input:checked ~ .custom-control-label::after {
        background-position: top 7px center;
    }
}

.cancel-btn {
    background-color:transparent; border-color:transparent; color:#3a3a3a; 

    &:hover {
        background-color: transparent !important;
        color:#3a3a3a !important;
        border-color: transparent !important;
    }
    &:focus {
        background-color: transparent !important;
        color:#3a3a3a !important;
        border-color: transparent !important;
        box-shadow: none !important;
    }
} 

div#delete-user-modal {
    background: transparent !important;
}

div#delete-user-modal___BV_modal_body_ {
    padding: 15px 5px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
}

#delete-user-modal___BV_modal_content_ {
    position: absolute;
    margin-left: 50%;
    margin-top: 30%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 50vw;
    z-index: 99;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    padding: 15px 15px;
}

div#activate-or-deactivate-user-modal {
    background: transparent !important;
}

div#activate-or-deactivate-user-modal___BV_modal_body_ {
    padding: 15px 5px;
    font-family: MainFontBold, sans-serif;
    font-weight: normal;
}

#activate-or-deactivate-user-modal___BV_modal_content_ {
    position: absolute;
    margin-left: 50%;
    margin-top: 30%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    width: 50vw;
    z-index: 99;
    box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
    padding: 15px 15px;
}

// MEDIA
@media only screen and (min-width: 320px) and (max-width: 374px) {
    #delete-user-modal___BV_modal_content_ {
        width: 305px !important;
        margin-left: 17%;
    }
    
    
    #activate-or-deactivate-user-modal___BV_modal_content_ {
        width: 305px !important;
        margin-left: 17%;
    }
}


@media only screen and (min-width: 375px) and (max-width: 424px) {
    #delete-user-modal___BV_modal_content_ {
        width: 360px !important;
        margin-left: 20%;
    }
    
    #activate-or-deactivate-user-modal___BV_modal_content_ {
        width: 360px !important;
        margin-left: 20%;
    }
}

@media only screen and (min-width: 425px) and (max-width: 767px) {
    #delete-user-modal___BV_modal_content_ {
        width: 410px !important;
        margin-left: 23%;
    }
    
    #activate-or-deactivate-user-modal___BV_modal_content_ {
        width: 410px !important;
        margin-left: 23%;
    }
}

@media only screen and (min-width: 768px) and (max-width: 1023px) {
    #delete-user-modal___BV_modal_content_ {
        width: 650px !important;
        margin-left: 43%;
    }
    
    #activate-or-deactivate-user-modal___BV_modal_content_ {
        width: 650px !important;
        margin-left: 43%;
    }
}

@media only screen and (min-width: 1024px) {
    #delete-user-modal___BV_modal_content_ {
        width: 650px !important;
        margin-left: 50%;
    }
    
    #activate-or-deactivate-user-modal___BV_modal_content_ {
        width: 650px !important;
        margin-left: 50%;
    }
}
</style>
